import React, { Component } from 'react';
import Select from 'react-select';
import { APIHandler, StorageHandler } from 'C4';
import { contentKeys, storageKeys, language } from 'settings';
import countryFlags from './countryFlags';

const changeLanguage = (e) => {
  const { value, label } = e;
  const [file] = language.filter(({ code: c, mainCode }) => c.includes(value) || (mainCode && mainCode.includes(value))).map(({ langFile }) => langFile);
  StorageHandler.removeKeys(contentKeys);
  StorageHandler.remove(storageKeys.progress);
  StorageHandler.save(storageKeys.lang, {
    country: label,
    code: value,
    langFile: file,
  });
  window.location.reload();
};

export default class LangSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      languages: [],
      selected: '',
      expand: false,
    };

    this.loadLanguages = this.loadLanguages.bind(this);
  }

  async componentDidMount() {
    this.loadLanguages();
    StorageHandler.load(storageKeys.lang).then(({ code, country }) => {
      const activeCountry = { value: code, label: country };
      this.setState({ selected: activeCountry });
    });
  }

  focusHandler() {
    this.setState(prevState => ({ expand: !prevState.expand }));
  }

  loadLanguages() {
    const availableCountries = language.map(({ countries }) => countries.map(country => country)).flat();
    const availableLanguages = language.map(({ code }) => code.map(c => c.toLowerCase())).flat();

    const codes = language.map(({ code, countries, mainCode }) => {
      if (countries.length >= 1) {
        if (code.length === 1) return code[0];
        if (countries.length > 1 && code.length > 1) return code;
        if (code.length > 1) return mainCode;
      }
      return `xx_${Date.now()}`;
    }).flat();

    StorageHandler.load(storageKeys.lang)
      .then((lang) => {
        if (!lang) {
          APIHandler.getLocation().then((location) => {
            const code = location.countryCode.toLowerCase();
            const [file] = language.filter(({ code: c }) => c.includes(code)).map(({ langFile }) => langFile);
            const [country] = language
              .filter(({ code: c }) => c.includes(code))
              .map(({ countries, code: c }) => countries[c.indexOf(code)] || countries[0]);
            if (location && availableLanguages.includes(code)) {
              let countryCode = location.countryCode.toLowerCase();
              const me = ['eg', 'ir', 'tr', 'iq', 'sa', 'ye', 'sy', 'jo', 'ae', 'il', 'lb', 'ps', 'om', 'kw', 'qa', 'bh'];
              if (me.includes(code)) {
                countryCode = 'meast';
              }
              StorageHandler.save(storageKeys.lang, {
                country,
                code: countryCode,
                langFile: file,
              });
              this.loadLanguages();
            } else {
              StorageHandler.exists(storageKeys.lang).then((localLanguage) => {
                if (!localLanguage) {
                  StorageHandler.save(storageKeys.lang, {
                    country: 'United States',
                    code: 'en',
                    langFile: 'en',
                  });
                }
              });
            }
          }).catch(() => {
            StorageHandler.save(storageKeys.lang, {
              country: 'United States',
              code: 'en',
              langFile: 'en',
            });
          });
        }

        const countryList = availableCountries.map((country, i) => ({
          value: codes[i],
          label: country,
        }));

        const activeCountry = { value: lang.code, label: lang.country };
        this.setState({ languages: countryList, selected: activeCountry });
      });
  }

  render() {
    const { selected, languages, expand } = this.state;
    const CountryFlag = ({ flag }) => {
      let flg = countryFlags.US;
      if (flag !== undefined && countryFlags[flag.toUpperCase()] !== undefined) {
        flg = countryFlags[flag.toUpperCase()];
      }
      const Flags = flg;
      return <Flags />;
    };

    // Context meant for differentiating between current selection and dropdown options
    const formatOptionLabel = ({ value, label }, { context }) => (
      <p className="customOption">
        <CountryFlag flag={value} />
        {/* {context === 'menu' && label} */}
        {label}
      </p>
    );

    return (
      <div className="lang__select" style={{ flex: (expand ? 3 : 1.05) }}>
        <Select
          value={selected}
          options={languages}
          onChange={changeLanguage}
          formatOptionLabel={formatOptionLabel}
          onFocus={() => this.focusHandler()}
          onBlur={() => this.focusHandler()}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>
    );
  }
}
